import { Router } from "@angular/router";
import { AlertController, ModalController } from "@ionic/angular";

export class CustomApplication {
    static instanceModalCtrl: ModalController
    static instanceRoute: Router
    static instanceAlertCtrl: AlertController
}